import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { GetSupplyEnquiriesByPkService } from '../services/get-supply-enquiries-by-pk.service';

@Injectable({
  providedIn: 'root'
})
export class GetSupplyEnquiriesResolver implements Resolve<boolean> {
  constructor(private getSupplyEnquiriesByPkService: GetSupplyEnquiriesByPkService){

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.getSupplyEnquiriesByPkService.getSupplyEnquiriesByPk(route.paramMap.get('id'));
  }
}
